import React, { FC } from 'react';
import { Loader, Title } from 'ui-library';
import BundleCard from '../BundleCard';

import '../BundledDocuments.css';
import { BundleSection } from '../BundledDocuments.types';

const BundledDocumentsOverview: FC<{
    filteredDocumentList: BundleSection[];
    documentsLoading: boolean;
}> = ({
    filteredDocumentList,
    documentsLoading,
}) => (
    <div className="bundled-documents">
        {documentsLoading && <Loader />}
        {filteredDocumentList?.map((section) => (
            <section key={section?.sectionTitle} className="bundled-documents__section">
                <Title type={2} className="font-normal mb-0">{section?.sectionTitle}</Title>
                <div className="bundled-documents__row">
                    {section?.cards?.map((card) => (
                        <BundleCard
                            key={card?.id}
                            productName={card?.product}
                            productSubtitle={card?.subtitle}
                            documents={card?.documents}
                            onEdit={card?.onEdit}
                        />
                    ))}
                </div>
            </section>
        ))}
    </div>
);

export default BundledDocumentsOverview;
